import Highcharts from 'highcharts';
import numeral from 'numeral';
import ColumnChart from './modules/column_chart.js';
import PieChart from './modules/pie_chart.js';
import Select from './modules/select.js';

numeral.locale('big');
Highcharts.setOptions({ lang: { numericSymbols: ['K', 'M', 'B', 'T'] } });

const ValueStatusChart = Object.create(PieChart);
ValueStatusChart.generateGroups = entries => _.groupBy(entries, entry => entry.status);

const ValueSectorsChart = Object.create(PieChart);
ValueSectorsChart.generateGroups = function (entries) {
  const sectorGroups = {};
  _.each(entries, entry => this.addOrInitSectorGroup(sectorGroups, entry));
  return sectorGroups;
};
ValueSectorsChart.translate = key => key;

const AwardedChart = Object.create(ColumnChart);
AwardedChart.generateGroups = function (entries) {
  if (this.selectedXAxis === 'quarters') {
    return _.groupBy(entries, entry => entry.main_contractor_awarded_at.formatted && moment.unix(entry.main_contractor_awarded_at.formatted).format("[Q]Q YYYY"));
  } else {
    return _.groupBy(entries, entry => entry.main_contractor_awarded_at.formatted && moment.unix(entry.main_contractor_awarded_at.formatted).year());
  }
};

AwardedChart.generateColumns = function (groups) {
  return _.chain(groups).keys().filter(e => parseInt(e, 10) || !!e.match(/Q[0-9] [0-9]{4}/)).sort(_.bind(this.columnSortFunc, this)).value();
};

const EndedChart = Object.create(ColumnChart);
EndedChart.generateGroups = function (entries) {
  if (this.selectedXAxis === 'quarters') {
    return _.groupBy(entries, entry => entry.ended_at && moment.unix(entry.ended_at).format("[Q]Q YYYY"));
  } else {
    return _.groupBy(entries, entry => entry.ended_at && moment.unix(entry.ended_at).year());
  }
};
EndedChart.generateColumns = function (groups) {
  return _.chain(groups).keys().filter(e => parseInt(e, 10) || !!e.match(/Q[0-9] [0-9]{4}/)).sort(_.bind(this.columnSortFunc, this)).value();
};

const CountryChart = Object.create(ColumnChart);
CountryChart.inputRenderers = ['renderCompanyTypeSelect', 'renderIsCountedSelect', 'renderSelect'];
CountryChart.renderCompanyTypeSelect = function (afterCallback) {
  afterCallback = function () {
    return this.render(this.entries);
  };
  return Select.init(this.containerId, ['all', 'consultants', 'contractors', 'developers', 'suppliers'], this.handleInputChange(this.onCompanyTypeChange, afterCallback), 'company_type').render();
};

CountryChart.onCompanyTypeChange = function (e) {
  return this.companyType = e.target.value === 'all' ?
    ['consultants', 'contractors', 'developers', 'suppliers']
    :
    [e.target.value];
};
CountryChart.inverted = true;
CountryChart.companyType = ['consultants', 'contractors', 'developers', 'suppliers'];
CountryChart.generateGroups = function (entries) {
  let tab = _.map(entries, entry => {
    return _.flatten(_.map(this.companyType, type => _.map(entry[type], project => [project, type, entry])), 1);
  });
  tab = _.flatten(tab, 1);
  tab = _.groupBy(tab, val => [val[0], val[1]].join('<br />'));
  tab = _.map(tab, (val, key) => [key, _.map(val, v => v[2])]);
  const sortFunc = this._isCounted ?
    val => val[1].length
    :
    val => _.reduce(val[1], ((mem, val) => mem + parseInt(val['formatted_budget'])), 0);

  tab = _.map(tab, arr => [arr[0], _.unique(arr[1], proj => proj.objectID)]);
  tab = _.sortBy(tab, sortFunc).slice(-5);
  return _.object(tab);
};

CountryChart.generateColumns = groups => _.keys(groups);

window.ProjectsBreakdown = {
  _timestamp: 0,
  _rendered: false,
  entries: [],
  container: $('#projects-breakdown'),

  chartsInfo: {
    _valueStatusCharts: {
      initializer() { return ValueStatusChart.init('status-breakdown-chart'); }
    },
    _valueSectorsCharts: {
      initializer() { return ValueSectorsChart.init('sectors-breakdown-chart'); }
    },
    _awardedChart: {
      initializer() { return AwardedChart.init('project-awarded-chart'); }
    },
    _endedChart: {
      initializer() { return EndedChart.init('project-completions-chart'); }
    },
    _countryChart: {
      initializer() { return CountryChart.init('country-breakdown-chart'); }
    }
  },

  _pageCount: Infinity,

  clearData(timestamp, pageCount) {
    this._timestamp = timestamp;
    this.entries = [];
    this._pageCount = pageCount;
    if (this._rendered) {
      for (let chart in this.chartsInfo) { this[chart].showSpinner(); }
    }
  },

  loadNoData() {
    return this.container.find('.spinner').hide();
  },

  loadData(data, ended, timestamp) {
    if (timestamp !== this._timeStamp) { return; }
    for (let el of Array.from(data.content.hits)) {
      el.location = _.last(el.location);
    }

    Array.prototype.push.apply(this.entries, data.content.hits);
    this.searchState = data.state;
    this._pageCount -= 1;
    if (this._pageCount === 0) {
      return this.render();
    }
  },

  initializeCharts() {
    for (let chart in this.chartsInfo) {
      const chartInfo = this.chartsInfo[chart];
      this[chart] = chartInfo.initializer();
    }
  },

  render() {
    if (!this._rendered) {
      this.container.find('.spinner').hide();
      this.initializeCharts();
      this._rendered = true;
    }

    for (let chart in this.chartsInfo) {
      this[chart].render(this.entries, this.searchState);
      this[chart].hideSpinner();
    }
  }
};
